import { put } from "redux-saga/effects";

import { apiFetch } from "common/utilities";
import { RequestError } from "common/utilities/requestError";
import { addKnowledgeFulfilled, addKnowledgeRejected } from "domains/pinAddReject/actions";
import type { AddKnowledge } from "domains/pinAddReject/actionTypes";

export function* addKnowledgeSaga(action: AddKnowledge) {
  const { link, topicIds } = action.meta;

  try {
    const payload: { knowledge_id: string } = yield apiFetch("knowledge", {
      method: "POST",
      body: {
        link,
        topic_ids: topicIds,
      },
    });
    yield put(addKnowledgeFulfilled(action.meta, { newKnowledgeId: payload.knowledge_id }));
    action.meta.onSuccess?.();
  } catch (error) {
    if (error instanceof RequestError)
      yield put(addKnowledgeRejected({ ...action.meta, logoutOnAuthError: true }, { errorStatus: error.status }));
    action.meta.onError?.();
  }
}
